import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource, MatPaginator, MatSort, MatDialog, MatDialogConfig } from '@angular/material';
import { IAplicacion } from 'src/app/modelos/aplicacion';
import { AplicacionesService } from 'src/app/servicios/aplicaciones.service';
import { NotificationsService } from 'angular2-notifications';
import { CrearEditarAplicacionComponent } from './crear-editar-aplicacion/crear-editar-aplicacion.component';

@Component({
  selector: 'app-aplicaciones',
  templateUrl: './aplicaciones.component.html',
  styleUrls: ['./aplicaciones.component.scss']
})
export class AplicacionesComponent implements OnInit {

  displayedColumns: string[] = ['index', 'nombre', 'acciones'];
  dataSource: MatTableDataSource<IAplicacion>;
  showSpinner = true;

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  constructor(
    private aplicacionesService: AplicacionesService,
    private notiticationsService: NotificationsService,
    public matDialog: MatDialog,

  ) {
    this.dataSource = new MatTableDataSource([]);
  }

  private listar() {
    this.aplicacionesService.listar().subscribe(
      (resp) => {
        console.log(resp);
        this.dataSource = new MatTableDataSource(resp);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.showSpinner = false;
      },
      (error) => {
        console.error(error);
        this.notiticationsService.error(error.error.mensaje);
        this.showSpinner = false;
      }
    );
  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }
  async eliminar(aplicacion: IAplicacion) {
    const confirmed = confirm('Eliminar la aplicación?');
    if (confirmed) {
      this.showSpinner = true;
      this.aplicacionesService.eliminar(aplicacion._id).subscribe(
        (resp) => {
          console.log(resp);
          this.notiticationsService.success(resp.mensaje);
          this.listar();
        },
        (error) => {
          console.error(error);
          this.notiticationsService.error(error.error.mensaje);
          this.showSpinner = false;
        }
      );
    }
  }

  crear() {
    const config: MatDialogConfig = {
      width: '500px',
      maxWidth: '90%',
      panelClass: 'client-form-dialog',
    };
    const modal = this.matDialog.open(CrearEditarAplicacionComponent, config);

    modal.afterClosed().subscribe(
      (result) => {
        if (result) {
          console.log(result);
          this.showSpinner = true;
          this.listar();
        }
      }
    );
  }

  ngOnInit() {
    this.listar();
  }

}
